module.exports = __webpack_public_path__ + "media/images/nav-dropdown-arrow-c9b951c924450771423a229aacaad15c.svg";